import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldX, ArrowLeft, Home } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { useAuth } from '../contexts/AuthContext';

const AccessDenied = ({ requiredRole = 'admin' }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  // Determine the correct home path based on user role
  const isEmployee = user?.role === 'funcionario' || user?.role === 'employee';
  const homePath = isEmployee ? '/meus-treinamentos' : '/';

  return (
    <div className="flex items-center justify-center min-h-[60vh]" data-testid="access-denied-page">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <ShieldX size={32} className="text-red-600" />
          </div>
          
          <h2 className="text-2xl font-bold text-slate-900 mb-2">
            Acesso Negado
          </h2>
          
          <p className="text-slate-600 mb-6">
            Você não tem permissão para acessar esta página. 
            Esta área é restrita para usuários com perfil de <strong>{requiredRole}</strong>.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button 
              variant="outline" 
              onClick={() => navigate(-1)}
              className="flex items-center gap-2"
            >
              <ArrowLeft size={16} />
              Voltar
            </Button>
            
            <Button 
              onClick={() => navigate(homePath)}
              className="bg-emerald-600 hover:bg-emerald-700 flex items-center gap-2"
            >
              <Home size={16} />
              Ir para Home
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccessDenied;
